import React, { useId } from 'react';
import { FieldError } from 'react-hook-form';

import { InputControl } from '../components/InputControl';
import { RawSelectSearch } from './RawSelectSearch';
import { Items, Item } from './types';

type SelectSearchProps = {
  placeholder?: string;
  label?: string;
  helpText?: string;
  error?: FieldError;
  disabled?: boolean;
  onChange: (value: Item | null) => void;
  items: Items;
  initialValue: Item['value'];
  emptyMessage: string;
  name?: string;
  maxHeight?: string;
  maxTextWidth?: string;
  showClearButton?: boolean;
  value?: Item['value'];
  condensed?: boolean;
  onInputChange?: (value: Item['value'] | null) => void;
};

const SelectSearch = ({
  placeholder,
  label,
  helpText,
  error,
  onChange,
  disabled,
  items,
  initialValue,
  name,
  maxHeight,
  maxTextWidth,
  showClearButton = true,
  value,
  emptyMessage,
  condensed,
  onInputChange,
}: SelectSearchProps) => {
  const labelId = useId();
  return (
    <InputControl
      condensed={condensed}
      error={error}
      helpText={helpText}
      label={label}
      labelId={labelId}
    >
      <RawSelectSearch
        labelId={label ? labelId : undefined}
        placeholder={placeholder}
        hasError={Boolean(error)}
        onChange={onChange}
        disabled={disabled}
        items={items}
        initialValue={initialValue}
        emptyMessage={emptyMessage}
        name={name}
        maxHeight={maxHeight}
        maxTextWidth={maxTextWidth}
        showClearButton={showClearButton}
        value={value}
        onInputChange={onInputChange}
      />
    </InputControl>
  );
};

export { SelectSearch };
